import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Store } from "@ngxs/store";
import { SupabaseService } from "apps/fluxos/src/app/shared/services/supabase.service";
import { Observable, switchMap, throwError, from, map, catchError, of } from "rxjs";
import { AuthService } from "../auth";
import { BaseCrudQuery } from "../base-crud.query";
import { UsersService } from "../users";
import { BroadcastContactListWithItems, BroadcastContactLists, DataMappingSchema, StudentDetailsAndCourses } from "@fluxos/data";

@Injectable({
    providedIn: 'root'
})
export class DataMappingQuery extends BaseCrudQuery<DataMappingSchema> {
  queryClientDataMappingSchema(organizationId: string): Observable<DataMappingSchema> {
    return this.getOne('client_data_mappings', `organization_id.eq.${organizationId}`, false).pipe(
      map(schema => {
        if (!schema) throw new Error('Schema not found');
        return schema as DataMappingSchema;
      })
    );
  }
}